var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

    pluginRegistry.registerFeature("Octopus.Features.WildflyDeployCLI", function() {
        return {
            title: "Deploy to WildFly/RedHat JBoss EAP",
            description: "Deploy to WildFly/RedHat JBoss EAP via the CLI",
            editTemplateUrl: "areas/projects/features/Octopus.Features.WildflyDeployCLI_edit.html",
            preLink: function (scope) {
                if (!scope.action.Properties['WildFly.Deploy.Debug']) {
                    scope.action.Properties['WildFly.Deploy.Debug'] = "False";
                }

                if (scope.action.Properties['WildFly.Deploy.Enabled'] != "True" &&
                    scope.action.Properties['WildFly.Deploy.Enabled'] != "False") {
                    scope.action.Properties['WildFly.Deploy.Enabled'] = "True";
                }

                if (!scope.action.Properties['WildFly.Deploy.Controller']) {
                    scope.action.Properties['WildFly.Deploy.Controller'] = "localhost";
                }

                if (!scope.action.Properties['WildFly.Deploy.Port']) {
                    scope.action.Properties['WildFly.Deploy.Port'] = "9990";
                }

                if (!scope.action.Properties['WildFly.Deploy.Protocol']) {
                    scope.action.Properties['WildFly.Deploy.Protocol'] = "remote+http";
                }

                if (!scope.action.Properties["WildFly.Deploy.ServerType"]) {
                    scope.action.Properties['WildFly.Deploy.ServerType'] = "Standalone";
                }
            },
            priority: 10,
            editLink: function($scope, element) {
            },
            enable: function(action, step) {
                action.Properties["Octopus.Features.WildflyDeployCLI"] = "True";
            },
            disable: function(action, step) {
                delete action.Properties["Octopus.Features.WildflyDeployCLI"];
            },
            validate: function(action, step, errors) {
                if (!action.Properties["WildFly.Deploy.Controller"]) {
                    errors.push("Please enter the WildFly Management Host or IP.");
                }
                if (!action.Properties["WildFly.Deploy.Port"]) {
                    errors.push("Please enter the WildFly Management Port.");
                }
                if (!action.Properties["WildFly.Deploy.Protocol"]) {
                    errors.push("Please enter the WildFly Management Protocol.");
                }
            }
        };
    });

});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.WildflyDeployCLI.js
// module id = 1857866317013779
// module chunks = 1